<template>


    <div class="main-drawer"  @click="display_click()">
        <div class="right-drawer">

            <div class="gp1">
                <div class="gp1-card">


                    <span class="drw-btn" @click="closedrawer">

                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="#414141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M17 9.5H3M21 4.5H3M21 14.5H3M17 19.5H3" /></svg>


                    </span>

                    <div class="gp-infocard0">

                        <img v-if="form.image===null||form.image===''" src="@/assets/img/logoes.png" width="65"
                            style="border-radius: 25%;background-color:#f3f3f3;" height="70">

                        <img v-else :src=form.image width="65" height="65" style="border-radius: 50%;">


                    </div>

                    <div class="gp-infocard">
                        <span class="infocard1">مدرسه مقاومت</span>
                        <span class="infocard2"></span>
                    </div>





                </div>


                <div class="gp2-card">


                    <router-link to="/" class="gp-item">

                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.5495 2.53189C11.3874 1.82531 12.6126 1.82531 13.4505 2.5319L20.2005 8.224C20.7074 8.65152 21 9.2809 21 9.94406V19.7468C21 20.7133 20.2165 21.4968 19.25 21.4968H15.75C14.7835 21.4968 14 20.7133 14 19.7468V14.2468C14 14.1088 13.8881 13.9968 13.75 13.9968H10.25C10.1119 13.9968 9.99999 14.1088 9.99999 14.2468V19.7468C9.99999 20.7133 9.2165 21.4968 8.25 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V9.94406C3 9.2809 3.29255 8.65152 3.79952 8.224L10.5495 2.53189ZM12.4835 3.6786C12.2042 3.44307 11.7958 3.44307 11.5165 3.6786L4.76651 9.37071C4.59752 9.51321 4.5 9.72301 4.5 9.94406V19.7468C4.5 19.8849 4.61193 19.9968 4.75 19.9968H8.25C8.38807 19.9968 8.49999 19.8849 8.49999 19.7468V14.2468C8.49999 13.2803 9.2835 12.4968 10.25 12.4968H13.75C14.7165 12.4968 15.5 13.2803 15.5 14.2468V19.7468C15.5 19.8849 15.6119 19.9968 15.75 19.9968H19.25C19.3881 19.9968 19.5 19.8849 19.5 19.7468V9.94406C19.5 9.72301 19.4025 9.51321 19.2335 9.37071L12.4835 3.6786Z"
                                fill="#414141" /></svg>
                        <span>
                            صفحه اصلی

                        </span>
                    </router-link>



                    <router-link to="/library" class="gp-item">

                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M18.25 3C19.7688 3 21 4.23122 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75C3 4.23122 4.23122 3 5.75 3H18.25ZM18.25 4.5H5.75C5.05964 4.5 4.5 5.05964 4.5 5.75V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5ZM14.25 11.5H6.75L6.64823 11.5068C6.28215 11.5565 6 11.8703 6 12.25C6 12.6642 6.33579 13 6.75 13H14.25L14.3518 12.9932C14.7178 12.9435 15 12.6297 15 12.25C15 11.8358 14.6642 11.5 14.25 11.5ZM6.75 15.5H17.25C17.6642 15.5 18 15.8358 18 16.25C18 16.6297 17.7178 16.9435 17.3518 16.9932L17.25 17H6.75C6.33579 17 6 16.6642 6 16.25C6 15.8703 6.28215 15.5565 6.64823 15.5068L6.75 15.5ZM17.25 7.5H6.75L6.64823 7.50685C6.28215 7.55651 6 7.8703 6 8.25C6 8.66421 6.33579 9 6.75 9H17.25L17.3518 8.99315C17.7178 8.94349 18 8.6297 18 8.25C18 7.83579 17.6642 7.5 17.25 7.5Z"
                                fill="#414141" /></svg>
                        <span>
                            کتابخانه
                        </span>
                    </router-link>



                    <router-link to="/courses" class="gp-item">

                        <svg fill="currentColor" height="32" viewBox="0 0 24 24" width="32"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.90878 3.69964C11.1832 2.88267 12.8168 2.88267 14.0912 3.69964L22.1548 8.86861C22.3689 9.0059 22.4989 9.24238 22.5 9.49677C22.5011 9.75116 22.3732 9.98876 22.1602 10.1279L19 12.1926V17.75C19 17.9122 18.9474 18.0701 18.85 18.2L18.8489 18.2014L18.8477 18.2031L18.8446 18.2071L18.8364 18.2178C18.8321 18.2233 18.8269 18.2298 18.8209 18.2373C18.8179 18.2411 18.8146 18.2452 18.8111 18.2495C18.7904 18.2751 18.7619 18.3095 18.7253 18.3513C18.6522 18.4348 18.5469 18.5483 18.4081 18.6816C18.1305 18.9481 17.7176 19.2948 17.1587 19.6387C16.0359 20.3297 14.3387 21 12 21C9.66127 21 7.96408 20.3297 6.8413 19.6387C6.2824 19.2948 5.86951 18.9481 5.59193 18.6816C5.45308 18.5483 5.34778 18.4348 5.27468 18.3513C5.23204 18.3025 5.1901 18.2531 5.15107 18.2014C5.14956 18.1994 5.15 18.2 5.15 18.2C5.05263 18.0701 5 17.9122 5 17.75V12.1926L3 10.8859V16.25C3 16.6642 2.66421 17 2.25 17C1.83579 17 1.5 16.6642 1.5 16.25V9.49997C1.5 9.22949 1.64318 8.99246 1.85788 8.86052L9.90878 3.69964ZM14.1194 15.3812C12.8317 16.2225 11.1683 16.2225 9.88058 15.3812L6.5 13.1725V17.4687C6.5368 17.5072 6.58034 17.5512 6.63073 17.5996C6.84143 17.8018 7.17072 18.0802 7.62745 18.3612C8.53592 18.9203 9.96373 19.5 12 19.5C14.0363 19.5 15.4641 18.9203 16.3726 18.3612C16.8293 18.0802 17.1586 17.8018 17.3693 17.5996C17.4197 17.5512 17.4632 17.5072 17.5 17.4687V13.1725L14.1194 15.3812ZM13.2817 4.96246C12.5006 4.46173 11.4994 4.46173 10.7183 4.96246L3.63041 9.506L10.701 14.1254C11.4902 14.6411 12.5098 14.6411 13.299 14.1254L20.3696 9.506L13.2817 4.96246Z"
                                fill="#414141" /></svg>
                        <span>
                            آموزش ها

                        </span>
                    </router-link>






                    <router-link to="/festival" class="gp-item">
                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.0256 12.1922C19.8772 12.4296 19.6806 12.6332 19.4486 12.7899L13.3987 16.8736C12.5535 17.4441 11.4465 17.4441 10.6013 16.8736L4.55142 12.7899C3.79043 12.2762 3.49533 11.3306 3.77229 10.5003L10.6132 15.0598C11.4005 15.5847 12.4112 15.6175 13.2264 15.1582L13.3867 15.0598L20.2271 10.4998C20.4088 11.0459 20.3545 11.666 20.0256 12.1922ZM20.2271 13.7498C20.4088 14.2959 20.3545 14.916 20.0256 15.4422C19.8772 15.6796 19.6806 15.8832 19.4486 16.0399L13.3987 20.1236C12.5535 20.6941 11.4465 20.6941 10.6013 20.1236L4.55142 16.0399C3.79043 15.5262 3.49533 14.5806 3.77229 13.7503L10.6132 18.3098C11.4005 18.8347 12.4112 18.8675 13.2264 18.4082L13.3867 18.3098L20.2271 13.7498ZM13.3867 3.42476L19.7519 7.66821C20.2115 7.97456 20.3356 8.59543 20.0293 9.05496C19.956 9.16481 19.8618 9.25907 19.7519 9.33231L13.3867 13.5758C12.547 14.1356 11.453 14.1356 10.6132 13.5758L4.24807 9.33231C3.78854 9.02595 3.66437 8.40509 3.97072 7.94556C4.04396 7.8357 4.13822 7.74144 4.24807 7.66821L10.6132 3.42476C11.453 2.86492 12.547 2.86492 13.3867 3.42476ZM11.5608 4.60648L11.4453 4.67283L5.705 8.50026L11.4453 12.3277C11.7439 12.5267 12.1228 12.5488 12.4392 12.394L12.5547 12.3277L18.294 8.50026L12.5547 4.67283C12.2561 4.47378 11.8772 4.45166 11.5608 4.60648Z"
                                fill="#414141" /></svg>
                        <span>

                            جشنواره و مسابقات

                        </span>
                    </router-link>


                    <router-link to="/research" class="gp-item">
                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.0256 12.1922C19.8772 12.4296 19.6806 12.6332 19.4486 12.7899L13.3987 16.8736C12.5535 17.4441 11.4465 17.4441 10.6013 16.8736L4.55142 12.7899C3.79043 12.2762 3.49533 11.3306 3.77229 10.5003L10.6132 15.0598C11.4005 15.5847 12.4112 15.6175 13.2264 15.1582L13.3867 15.0598L20.2271 10.4998C20.4088 11.0459 20.3545 11.666 20.0256 12.1922ZM20.2271 13.7498C20.4088 14.2959 20.3545 14.916 20.0256 15.4422C19.8772 15.6796 19.6806 15.8832 19.4486 16.0399L13.3987 20.1236C12.5535 20.6941 11.4465 20.6941 10.6013 20.1236L4.55142 16.0399C3.79043 15.5262 3.49533 14.5806 3.77229 13.7503L10.6132 18.3098C11.4005 18.8347 12.4112 18.8675 13.2264 18.4082L13.3867 18.3098L20.2271 13.7498ZM13.3867 3.42476L19.7519 7.66821C20.2115 7.97456 20.3356 8.59543 20.0293 9.05496C19.956 9.16481 19.8618 9.25907 19.7519 9.33231L13.3867 13.5758C12.547 14.1356 11.453 14.1356 10.6132 13.5758L4.24807 9.33231C3.78854 9.02595 3.66437 8.40509 3.97072 7.94556C4.04396 7.8357 4.13822 7.74144 4.24807 7.66821L10.6132 3.42476C11.453 2.86492 12.547 2.86492 13.3867 3.42476ZM11.5608 4.60648L11.4453 4.67283L5.705 8.50026L11.4453 12.3277C11.7439 12.5267 12.1228 12.5488 12.4392 12.394L12.5547 12.3277L18.294 8.50026L12.5547 4.67283C12.2561 4.47378 11.8772 4.45166 11.5608 4.60648Z"
                                fill="#414141" /></svg>
                        <span>

                            پژوهش

                        </span>
                    </router-link>

                    <router-link to="/ziarat" class="gp-item">
                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.0256 12.1922C19.8772 12.4296 19.6806 12.6332 19.4486 12.7899L13.3987 16.8736C12.5535 17.4441 11.4465 17.4441 10.6013 16.8736L4.55142 12.7899C3.79043 12.2762 3.49533 11.3306 3.77229 10.5003L10.6132 15.0598C11.4005 15.5847 12.4112 15.6175 13.2264 15.1582L13.3867 15.0598L20.2271 10.4998C20.4088 11.0459 20.3545 11.666 20.0256 12.1922ZM20.2271 13.7498C20.4088 14.2959 20.3545 14.916 20.0256 15.4422C19.8772 15.6796 19.6806 15.8832 19.4486 16.0399L13.3987 20.1236C12.5535 20.6941 11.4465 20.6941 10.6013 20.1236L4.55142 16.0399C3.79043 15.5262 3.49533 14.5806 3.77229 13.7503L10.6132 18.3098C11.4005 18.8347 12.4112 18.8675 13.2264 18.4082L13.3867 18.3098L20.2271 13.7498ZM13.3867 3.42476L19.7519 7.66821C20.2115 7.97456 20.3356 8.59543 20.0293 9.05496C19.956 9.16481 19.8618 9.25907 19.7519 9.33231L13.3867 13.5758C12.547 14.1356 11.453 14.1356 10.6132 13.5758L4.24807 9.33231C3.78854 9.02595 3.66437 8.40509 3.97072 7.94556C4.04396 7.8357 4.13822 7.74144 4.24807 7.66821L10.6132 3.42476C11.453 2.86492 12.547 2.86492 13.3867 3.42476ZM11.5608 4.60648L11.4453 4.67283L5.705 8.50026L11.4453 12.3277C11.7439 12.5267 12.1228 12.5488 12.4392 12.394L12.5547 12.3277L18.294 8.50026L12.5547 4.67283C12.2561 4.47378 11.8772 4.45166 11.5608 4.60648Z"
                                fill="#414141" /></svg>
                        <span>

                            زیارت مجازی

                        </span>
                    </router-link>
                    <router-link to="/about-us" class="gp-item">
                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.0256 12.1922C19.8772 12.4296 19.6806 12.6332 19.4486 12.7899L13.3987 16.8736C12.5535 17.4441 11.4465 17.4441 10.6013 16.8736L4.55142 12.7899C3.79043 12.2762 3.49533 11.3306 3.77229 10.5003L10.6132 15.0598C11.4005 15.5847 12.4112 15.6175 13.2264 15.1582L13.3867 15.0598L20.2271 10.4998C20.4088 11.0459 20.3545 11.666 20.0256 12.1922ZM20.2271 13.7498C20.4088 14.2959 20.3545 14.916 20.0256 15.4422C19.8772 15.6796 19.6806 15.8832 19.4486 16.0399L13.3987 20.1236C12.5535 20.6941 11.4465 20.6941 10.6013 20.1236L4.55142 16.0399C3.79043 15.5262 3.49533 14.5806 3.77229 13.7503L10.6132 18.3098C11.4005 18.8347 12.4112 18.8675 13.2264 18.4082L13.3867 18.3098L20.2271 13.7498ZM13.3867 3.42476L19.7519 7.66821C20.2115 7.97456 20.3356 8.59543 20.0293 9.05496C19.956 9.16481 19.8618 9.25907 19.7519 9.33231L13.3867 13.5758C12.547 14.1356 11.453 14.1356 10.6132 13.5758L4.24807 9.33231C3.78854 9.02595 3.66437 8.40509 3.97072 7.94556C4.04396 7.8357 4.13822 7.74144 4.24807 7.66821L10.6132 3.42476C11.453 2.86492 12.547 2.86492 13.3867 3.42476ZM11.5608 4.60648L11.4453 4.67283L5.705 8.50026L11.4453 12.3277C11.7439 12.5267 12.1228 12.5488 12.4392 12.394L12.5547 12.3277L18.294 8.50026L12.5547 4.67283C12.2561 4.47378 11.8772 4.45166 11.5608 4.60648Z"
                                fill="#414141" /></svg>
                        <span>

                            درباره ما

                        </span>
                    </router-link>



                    <router-link to="/linkus" class="gp-item">
                        <svg fill="none" height="32" viewBox="0 0 24 24" width="32" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M20.0256 12.1922C19.8772 12.4296 19.6806 12.6332 19.4486 12.7899L13.3987 16.8736C12.5535 17.4441 11.4465 17.4441 10.6013 16.8736L4.55142 12.7899C3.79043 12.2762 3.49533 11.3306 3.77229 10.5003L10.6132 15.0598C11.4005 15.5847 12.4112 15.6175 13.2264 15.1582L13.3867 15.0598L20.2271 10.4998C20.4088 11.0459 20.3545 11.666 20.0256 12.1922ZM20.2271 13.7498C20.4088 14.2959 20.3545 14.916 20.0256 15.4422C19.8772 15.6796 19.6806 15.8832 19.4486 16.0399L13.3987 20.1236C12.5535 20.6941 11.4465 20.6941 10.6013 20.1236L4.55142 16.0399C3.79043 15.5262 3.49533 14.5806 3.77229 13.7503L10.6132 18.3098C11.4005 18.8347 12.4112 18.8675 13.2264 18.4082L13.3867 18.3098L20.2271 13.7498ZM13.3867 3.42476L19.7519 7.66821C20.2115 7.97456 20.3356 8.59543 20.0293 9.05496C19.956 9.16481 19.8618 9.25907 19.7519 9.33231L13.3867 13.5758C12.547 14.1356 11.453 14.1356 10.6132 13.5758L4.24807 9.33231C3.78854 9.02595 3.66437 8.40509 3.97072 7.94556C4.04396 7.8357 4.13822 7.74144 4.24807 7.66821L10.6132 3.42476C11.453 2.86492 12.547 2.86492 13.3867 3.42476ZM11.5608 4.60648L11.4453 4.67283L5.705 8.50026L11.4453 12.3277C11.7439 12.5267 12.1228 12.5488 12.4392 12.394L12.5547 12.3277L18.294 8.50026L12.5547 4.67283C12.2561 4.47378 11.8772 4.45166 11.5608 4.60648Z"
                                fill="#414141" /></svg>
                        <span>

                            ارتباط با ما

                        </span>
                    </router-link>

                </div>



            </div>


            <!-- <logoutLoading  /> -->

        </div>

    </div>


</template>



<script>
    import jQuery from 'jquery';
    let $ = jQuery;
    //import axios from 'axios';
    //import logoutLoading from '@/components/panel/logoutLoading.vue';
    import AOS from 'aos'
    export default {

        components: {
            //logoutLoading
        },
        data() {
            return {
                form: {
                    name: 'نام و نام خانوادگی',
                    mobile: '',
                    image: ''
                },
                isclosed: ''
            }
        },


        methods: {
            logouts2() {
                this.$emit('logoutmodal')
                this.$utils.logouts2();

            },

            closedrawer() {


                /// $('.right-drawer').css('right', '-220px');
                $(".main-drawer").removeClass("show");
                $(".main-drawer").addClass("hide");



            },

            display_click() {
              //  $('.main-drawer').css('display', 'none');
                $(".main-drawer").removeClass("show");
                $(".main-drawer").addClass("hide");
            }
        },


        computed: {

        },
        mounted() {


            AOS.init();

        },
        watch: {
            $route(to, from) {
                $('.right-drawer').css('right', '-220px');
                from;
                to;
                ///this.show = false;
            }
        }



    };
</script>

<style scoped>
    /* .router-link-exact-active {

	} */


    .router-link-active {
        transition: all .2s ease;
        visibility: visible !important;
        box-shadow: inset 70px 0 40px -40px #7883b721 !important;
        /* border-color: #f0eeff !important; */
        border-right: 5px solid #7883b7c4;

    }

    a {
        text-decoration: none;
    }

    .gp1 {

        display: flex;
        justify-content: center;
        align-items: center;
        /* padding: 10px; */
        /* flex: 0 0 25%;
max-width: 25%;
min-height: 100px; */
        margin-top: 100px;
        flex-direction: column;
    }

    /* .gp-item:nth-child(7) {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;

	} */

    .gp1-card {
        display: flex;
        /* border-bottom: 1px solid #efefef; */
        /* border-left: 1px solid #efefef; */

        /* min-height: 80px; */
        width: 100%;
        padding: 5px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        flex-direction: column;
        margin: 10px 0px;
    }


    .gp-infocard {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        /* margin-right: 15px; */
    }

    .gp-infocard0 {
        display: flex;
        align-items: center;
        justify-content: center;

    }

    .infocard1 {
        display: flex;
        text-align: center;
        color: #414141;
        font-weight: 500;
        margin-top: 10px;
        width: 100%;
        justify-content: center;
        font-size: 14px;

    }

    /* .gp-item:hover {
		background-color: #ececec6c;
	} */


    .gp-item span {
        color: #414141;
        font-weight: 500;
        font-size: 1rem;
        margin-right: 12px;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        display: flex;
    }

    .gp-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 15px 20px;
        /* border-bottom: 1px solid #efefef; */
        cursor: pointer;
    }

    .infocard2 {
        display: flex;
        text-align: center;
        color: rgb(110, 110, 110);
        font-weight: 300;
        margin-top: 10px;
        width: 100%;
        justify-content: center;
        font-size: 15px;

    }


    .gp2-card {
        display: flex;
        /* border-left: 1px solid #efefef; */
        border-top: none;
        width: 100%;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        flex-direction: column;
    }

    .right-drawer {

        border-left: 1px solid #efefef;
        width: 220px;
        height: 100%;
        position: fixed;
        top: 80px;
        bottom: 0;
        right: 0;
        z-index: 99;
        color: #5a5a50;

        overflow-y: auto;
        transition: .25s cubic-bezier(.4, 0, .2, 1);
        overflow-y: auto;
        will-change: transform, width;
        border-left: 1px solid #d8d8d84d;
        z-index: 88;
        transition: right .2s cubic-bezier(0.0820, 0.085, 0.0395, 0.0895);
        padding-bottom: 100px;
        right: 0px !important;
        /* border-left: 1px solid hsla(0,0%,84.7%,.30196078431372547);
    box-shadow: 0 0 5px 0 rgb(0 0 0 / 10%), 0 0 1px 0 rgb(0 0 0 / 10%); */

    }

    .drw-btn {
        display: none;
        cursor: pointer;
        padding-left: 17px;
        justify-content: flex-end;

    }



    @media (min-width: 1050px) {
        .right-drawer {
            right: 0px !important;
        }



    }






    @media (max-width: 1050px) {
        .gp-item {
            border: none !important;
        }

        .drw-btn {
            display: flex;
        }

        .right-drawer {
            right: 0px;

            background-color: #fff;
            top: 0px !important;
            box-shadow: rgba(0, 0, 0, 0.22) 0px 2px 20px;

        }


        .gp1 {
            flex: 0 0 100%;
            width: 100%;
            max-width: 100%;

            margin-top: 0px;

        }

        .gp-item span {

            color: #414141;
            font-weight: 300;
            font-size: 14px;
            font-weight: 600;

        }

        .gp2-card {
            border-radius: 8px;
            margin-top: 20px;
        }

        .gp-item:nth-child(1) {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
    }

    .main-drawer {

        display: flex;
        /* Hidden by default */
        position: fixed;
        /* Stay in place */
        z-index: 8888;
        /* Sit on top */

        /* Location of the box */
        left: 0;
        top: 0;
        width: 100%;
        /* Full width */
        height: 100%;
        /* Full height */
        overflow: auto;
        /* Enable scroll if needed */
        /* Fallback color */
        background-color: rgba(0, 0, 0, 0.5);
        will-change: transform, opacity;

        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: #6f6f6f6b;


        will-change: transform, width;
        border-left: 1px solid #d8d8d84d;
        z-index: 88;
        transition: right .2s cubic-bezier(0.0820, 0.085, 0.0395, 0.0895);
        animation: 3s linear 0s infinite alternate move;
        overflow-y: hidden;
    }



    /**********************/

    .right-drawer {
        background-color: #fff;
        border: 1px solid #bbbbbb;
    }

    .right-drawer .active {
        left: 20px;
        transform: translateX(0%);
    }

    .main-drawer::after {
        content: "";
        clear: both;
        display: table;
    }

    .clearfix::after {
        content: "";
        clear: both;
        display: table;
    }



    .btn-default {
        background-color: #fff;
        padding: 10px;
        border: 1px solid #bbbbbb;
        width: 150px;
    }

    .btn-default:hover {
        cursor: pointer;
        box-shadow: inset 0 1px 3px 0 #bbbbbb;
    }

    .btngroup {
        text-align: right
    }

    .main-drawer {
        right: -100%;
        visibility: visible;
        transition: 0.6s;
    }

    .main-drawer.show {
        visibility: visible;
        right: 0;
    }

    .main-drawer.hide {
        visibility: hidden;
        right: -100%;
    }
</style>